const getProtooUrl = ({ roomId, peerId, userToken }) => {
  const apiKey = process.env.REACT_APP_CLIENT_HUDDLE_API_KEY;
  return `wss://media.huddle01.com/?roomId=${roomId}&peerId=${peerId}&apiKey=${apiKey}&userToken=${userToken}`;
};

export default getProtooUrl;
